"use client";

import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect, useId, useRef } from "react";

type IndicatorListProps = {
  instruments: { feed: number; ticker: string }[];
};

const IndicatorList = (props: IndicatorListProps) => {
  const router = useRouter();
  const { isReady, load } = useInfront();
  const uid = useId();
  const ID = "indicator-list" + uid.replace(/:/g, "");
  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(
      () => {
        if (!isReady || !active) return;

        widgetRef.current?.destroy();
        widgetRef.current = null;

        const widgetOptions = new window.Infront.QuoteListWidgetOptions();

        widgetOptions.onInstrumentSelected = (instrument: {
          feed: number;
          ticker: string;
        }) => {
          router.push(
            createInstrumentSlug(instrument.feed, instrument.ticker),
          );
        };

        widgetOptions.widgetTitle = "Indikatorer";
        widgetOptions.instruments = props.instruments;
        widgetOptions.defaultContent = DEFAULT_CONTENT;
        widgetOptions.enableChangeStatusColors = true;

        widgetOptions.columns = [
          {
            name: "TICKER",
            flag: true,
          },
          "LAST",
          "PCT_CHANGE",
          "TIME",
        ];

        widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);
      },
    );

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, router, props.instruments]);

  return <div className="card" id={ID} />;
};

export default IndicatorList;
